import { seoContent } from '@/mocks/content';
import { useRef, useState } from 'react';

const NEWSLETTER_SUBMIT_ADDR = 'https://readdy.ai/api/form/d8vrr6o4jh3v1cgkshm0';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const botRef = useRef<HTMLInputElement>(null);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    const botValue = botRef.current?.value?.trim() || '';
    if (botValue) {
      setStatus('success');
      setMessage('Inscrição realizada com sucesso! Verifique seu email.');
      setEmail('');
      setTimeout(() => { setStatus('idle'); setMessage(''); }, 4000);
      return;
    }

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const resp = await fetch(NEWSLETTER_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (resp.ok) {
        setStatus('success');
        setMessage('Inscrição realizada com sucesso! Verifique seu email.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Erro ao inscrever. Tente novamente.');
      }
    } catch {
      setStatus('error');
      setMessage('Erro de conexão. Tente novamente mais tarde.');
    }
    setTimeout(() => { setStatus('idle'); setMessage(''); }, 4000);
  };

  return (
    <section className="relative w-full flex flex-col md:flex-row min-h-[500px] md:h-[520px]">
      <div className="md:w-1/2 relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20shopping%20collection%20artistically%20laid%20out%20on%20cream%20linen%2C%20soft%20morning%20sunlight%20streaming%20from%20side%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20aesthetic%2C%20various%20fashion%20items%20and%20accessories%2C%20clean%20sophisticated%20composition%2C%20gentle%20shadows%2C%20inviting%20atmosphere&width=800&height=600&seq=cta-v2-left&orientation=landscape"
          alt="Acesse a planilha completa"
          title="CSSBuySpreadsheet - A Planilha Completa"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 p-8 md:p-12">
          <span className="text-xs text-white/60 uppercase tracking-wider">{seoContent.ctaTitle}</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-tight mt-2">
            {seoContent.ctaTitleLine2}
            <br />
            {seoContent.ctaTitleLine3}
          </h2>
        </div>
      </div>

      <div className="md:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 py-16 md:py-0">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-5">
            {seoContent.ctaHeadline}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            {seoContent.ctaDescription}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-primary-500 text-primary-600 font-semibold text-sm md:text-base hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap"
            >
              CSSBuy Sheet
            </a>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <p className="text-xs text-foreground-500 uppercase tracking-wider mb-4 font-semibold">NEWSLETTER</p>
            <form onSubmit={handleNewsletter} data-readdy-form="" className="relative">
              <input
                ref={botRef}
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="form-anti-bot"
              />
              <div className="flex items-center border-b border-foreground-300 focus-within:border-primary-500 transition-colors">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={seoContent.newsletterPlaceholder}
                  required
                  className="flex-1 bg-transparent py-2.5 text-sm text-foreground-800 placeholder-foreground-400 outline-none"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer p-2 whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              <p className="text-xs text-foreground-400 mt-2 text-left">
                {seoContent.newsletterHint}
              </p>
              {message && (
                <p className={`text-xs mt-2 text-left ${status === 'success' ? 'text-accent-600' : 'text-red-500'}`}>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}